import { z } from 'zod'

export const CurrencySchema = z.enum([
  'BRL',
  'USD',
  'EUR',
  'CLP',
  'PEN',
  'COP',
  'MXN',
  'CAD',
  'JPY',
  'GBP',
  'DKK',
  'NOK',
  'SEK',
  'PYG',
  'CHF',
])
export type Currency = z.infer<typeof CurrencySchema>

export const SaleStatusSchema = z.enum([
  'PENDING',
  'PAID',
  'FAILED',
  'REFUND_REQUESTED',
  'REFUNDED',
  'CHARGED_BACK',
])
export type SaleStatus = z.infer<typeof SaleStatusSchema>
export const SALE_STATUSES = SaleStatusSchema.options

export const GatewaySchema = z.enum(['STRIPE', 'MERCADO_PAGO', 'PAYPAL', 'BRASIL_BITCOIN'])
export type Gateway = z.infer<typeof GatewaySchema>

export const PaymentMethodSchema = z.enum([
  'CREDIT_CARD',
  'PIX',
  'BOLETO',
  'PAYPAL',
  'APPLE_PAY',
  'GOOGLE_PAY',
  'AMAZON_PAY',
])
export type PaymentMethod = z.infer<typeof PaymentMethodSchema>

export const ReceivingPeriodSchema = z.enum(['D2', 'D5', 'D14', 'D30'])
export type ReceivingPeriod = z.infer<typeof ReceivingPeriodSchema>

export const LedgerEntryTypeSchema = z.enum(['USER', 'COMMISSION', 'VENDEPAY', 'RESERVE'])
export type LedgerEntryType = z.infer<typeof LedgerEntryTypeSchema>

export const LedgerEntryStatusSchema = z.enum([
  'PENDING',
  'PROCESSING',
  'PROCESSING_PARTIAL',
  'PAID',
  'REVOKED',
  'DEBT_SETTLED',
  'DEBT_SETTLED_PARTIAL',
])
export type LedgerEntryStatus = z.infer<typeof LedgerEntryStatusSchema>

export const LedgerEntrySourceSchema = z.enum([
  'SALE',
  'WITHDRAWAL_REMAINDER',
  'DEBT_REMAINDER',
  'CURRENCY_CONVERSION',
])
export type LedgerEntrySource = z.infer<typeof LedgerEntrySourceSchema>

export const DebtOriginSchema = z.enum([
  'CHARGEBACK',
  'ESTORNO',
  'GLOBAL_CHARGEBACK_FEE',
  'FX_LOSS',
])
export type DebtOrigin = z.infer<typeof DebtOriginSchema>

export const DebtStatusSchema = z.enum(['PENDING', 'SETTLED', 'REVERSED'])
export type DebtStatus = z.infer<typeof DebtStatusSchema>

export const SubscriptionStatusSchema = z.enum(['TRIALING', 'ACTIVE', 'PAST_DUE', 'CANCELED'])
export type SubscriptionStatus = z.infer<typeof SubscriptionStatusSchema>

export const InvoiceStatusSchema = z.enum([
  'PENDING',
  'PROCESSING',
  'PAID',
  'PAST_DUE',
  'IN_GRACE',
  'AWAITING_ACTION',
  'BLOCKED',
  'FAILED',
  'CANCELED',
])
export type InvoiceStatus = z.infer<typeof InvoiceStatusSchema>

export const ProductStatusSchema = z.enum(['DRAFT', 'ACTIVE', 'ARCHIVED'])
export type ProductStatus = z.infer<typeof ProductStatusSchema>

export const AffiliateAgreementStatusSchema = z.enum(['PENDENTE', 'APROVADO', 'RECUSADO'])
export type AffiliateAgreementStatus = z.infer<typeof AffiliateAgreementStatusSchema>

export const CoproductionInviteStatusSchema = z.enum(['PENDENTE', 'ATIVO', 'REMOVIDO'])
export type CoproductionInviteStatus = z.infer<typeof CoproductionInviteStatusSchema>

export const DocumentationStatusSchema = z.enum([
  'NAO_INICIADO',
  'PENDENTE',
  'APROVADO',
  'REPROVADO',
])
export type DocumentationStatus = z.infer<typeof DocumentationStatusSchema>
